
<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('setpaypwd.modifyPaymentPassword')}}</div>
        </div>
        <div class="wrap">
            <!-- 旧密码输入框 -->
            <div class="write_box">
                <input :type="passwordInp" v-model="oldPassword" :placeholder="$t('setpaypwd.oldpassword')">
                <div class="eye_bi" @click="showPwd" :class="passwordInp=='text'?'eye':''"></div>
            </div>
            <!-- 新密码设置部分 -->
            <div class="write_new_pwd">
                <div class="write_box">
                    <!-- 这里取消了 disabled, 可以直接输入 -->
                    <input :type="newpasswordInp" v-model="npassword" :placeholder="$t('setpaypwd.newpassword')">
                    <div class="eye_bi" @click="showNewsPwd" :class="newpasswordInp=='text'?'eye':''"></div>
                </div>
                <div class="write_box">
                    <!-- 这里取消了 disabled, 可以直接输入 -->
                    <input :type="newpasswordInp" v-model="rpassword" :placeholder="$t('setpwd.confirmnewpassword')">
                    <div class="eye_bi" @click="showNewsPwd" :class="newpasswordInp=='text'?'eye':''"></div>
                </div>
            </div>
        </div>
        <!-- 提交按钮 -->
        <div class="basic_btn" :class="oldPassword!='' && npassword!='' && rpassword!='' ? '' : 'no_touch'" @click="submitModify">
            {{$t('setpwd.modify')}}
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { CountDown, Toast } from 'vant'; // 引入 Toast
import Fetch from '../../utils/fetch'

Vue.use(CountDown);
Vue.use(Toast); // 注册 Toast 组件

export default {
    name: "setpwd",
    data() {
        return {
            oldPassword: '', // 旧支付密码
            rpassword: '',   // 确认新支付密码
            npassword: '',   // 新支付密码
            passwordInp: 'password', // 控制旧密码输入框类型
            newpasswordInp: 'password', // 控制新密码输入框类型
        };
    },
    created() {
        this.$parent.footer('user', false); // 假设你的父组件有这个方法来控制底部导航
    },
    methods: {
        // 切换旧密码输入框的显示类型 (密码/文本)
        showPwd() {
            this.passwordInp = (this.passwordInp === 'password') ? 'text' : 'password';
        },
        // 切换新密码输入框的显示类型 (密码/文本)
        showNewsPwd() {
            this.newpasswordInp = (this.newpasswordInp === 'password') ? 'text' : 'password';
        },
        // 提交修改支付密码
        submitModify() {
            if (!this.oldPassword) {
                Toast(this.$t('setpaypwd.oldpasswordcannotbeempty'));
                return false;
            }

            if (!this.npassword) {
                Toast(this.$t('setpaypwd.newpasswordcannotbeempty'));
                return false;
            }

            if (this.npassword.length < 6 ) {
                Toast(this.$t('setpaypwd.passwordLength6')); // 假设有这个多语言文本，提示密码长度为6位
                return false;
            }

            if (this.npassword !== this.rpassword) {
                Toast(this.$t('setpaypwd.inconsistent'));
                return false;
            }

            // 检查新密码是否为纯数字
            const reg = /^[0-9]{6}$/; // 严格匹配6位纯数字
            if (!reg.test(this.npassword)) {
                Toast(this.$t('setpaypwd.pureNumber'));
                return false;
            }

            // 调用接口进行修改
            Fetch('/user/resetpaypwd', {
                password: this.oldPassword, // 传入旧支付密码
                npassword: this.npassword, // 传入新支付密码
            }).then(() => {
                Toast({
                    background: '#07c160',
                    message: this.$t('setpwd.modifiedsuccessfully')
                });
                // 修改成功后跳转到安全中心页面
                this.$router.replace('/user');
            }).catch(error => {
                // Fetch 会在这里处理错误，例如显示错误信息
                // 如果你的Fetch工具不自动toast错误，你可以在这里手动处理
                Toast(error.message || '修改失败');
            });
        },
    }
};
</script>

<style lang="less" scoped>
	.back_left {
		background: url(../../views/images/item/back_b.png) no-repeat center center;
	}
	.big_tit{
		color: #000000;
	}
    .wrap {
        padding: 35px 20px 0 20px;
    }
    .no_touch{
        pointer-events: none;
    }

    .title {
        width: 100%;
        height: 25px;
        line-height: 25px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
            font-size: 18px;
            color: #000;
            font-weight: 400;
        }

        .cut {
            font-size: 12px;
            color: #3D96FF;
        }
    }

    .bd_tel {
        margin-top: 23px;
        color: #000;
        font-size: 14px;
        font-weight: 400;
    }

    .inp_box {
        display: flex;
        justify-content: space-between;
        height: 45px;
        margin-top: 9px;

        .inp {
            width: 195px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 10px;
            border-radius: 2px;
            background-color: #FFFFFF;

            input {
                width: 100%;
                height: 22px;
                line-height: 22px;
                font-size: 16px;
            }
        }

        .getcode {
            flex: 1;
            margin-left: 10px;
            font-size: 16px;
            text-align: center;
            line-height: 45px;
            color: #FFFFFF;
            height: 45px;
            background: linear-gradient(90deg, rgba(228, 57, 46, 1) 0%, rgba(255, 77, 22, 1) 100%);
            border-radius: 8px;
        }

        .reset_code {
            background: rgba(228, 228, 228, 1);
            color: rgba(0, 0, 0, 0.3);
        }
    }

    .write_box {
        width: 100%;
        height: 45px;
        margin-top: 32px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        border-radius: 2px;
        background-color: #FFFFFF;

        input,.wordBox {
            width: 100%;
            height: 22px;
            line-height: 22px;
            font-size: 16px;
        }
    }

    .eye_bi {
        width: 21px;
        height: 25px;
        background: url(../images/user/eye2.png) no-repeat center center;
        background-size: 100% auto;

        &.eye {
            background: url(../images/user/eye1.png) no-repeat center center;
            background-size: 100% auto;
        }
    }

    .basic_btn {
        margin: 43px auto 0 auto;
    }

    .write_new_pwd {
        margin-top: 32px;

        .write_box:first-child {
            margin-bottom: 18px;
            margin-top: 0px;
        }

        .write_box:last-child {
            margin-top: 0px;
        }
    }
    
    /deep/ .van-password-input {
    	margin: 50px 28px 0 28px;
    }
    
    /deep/ .van-hairline--left::after {
    	border: 1px solid #ECECEC;
    }
    
    .van-password-input .van-password-input__security::after {
    	border-radius: 0;
    }
    
    .keybord_box {
    	height: 250px;
    	background-color: #F0F0F0;
    	margin-top: 35px;
    	padding: 24px 12px 0 12px;
    	.keybord{
    		width: 361px;
    		margin: 24px auto 0 atuo;
    		display: flex;
    		justify-content: space-between;
    		flex-wrap: wrap;
    		text-align: center;
    		.key_item{
    			width: 115px;
    			height: 44px;
    			line-height: 44px;
    			font-size: 18px;
    			font-weight: bold;
    			margin-bottom: 6px;
    			background:rgba(255,255,255,1);
    			border-radius:3px;
    			&.no_bg{
    				background: none;
    			}
    			&.x{
    				color: #757880;
    				font-weight: bold;
    			}
    		}
    	}
    }
</style>
